import { useEffect, useState } from "react";
import {
  WORKFLOW_STEP_STATUS_ENUM,
  workStepNameToUI,
} from "../../api/Workflows";
import { classNames } from "../../utils";
import { FunnelIcon } from "@heroicons/react/24/outline";
import { Modal } from "../../shared-components/Modal";
import Button from "../../shared-components/Button";

let WORKFLOW_STEP_STATUS_LIST: WORKFLOW_STEP_STATUS_ENUM[] = [
  WORKFLOW_STEP_STATUS_ENUM.PersonScrape,
  WORKFLOW_STEP_STATUS_ENUM.ProfilesModelPredict,
  WORKFLOW_STEP_STATUS_ENUM.ProfilesAutoRate,
  WORKFLOW_STEP_STATUS_ENUM.ProfilesManualRate,
  WORKFLOW_STEP_STATUS_ENUM.PersonEnrichment,
  WORKFLOW_STEP_STATUS_ENUM.PostsManualScrape,
  WORKFLOW_STEP_STATUS_ENUM.ProfilePostScrape,
  WORKFLOW_STEP_STATUS_ENUM.KeywordMatch,
  WORKFLOW_STEP_STATUS_ENUM.PostsModelPredict,
  WORKFLOW_STEP_STATUS_ENUM.PostsAutoRate,
  WORKFLOW_STEP_STATUS_ENUM.PostsManualRate,
  WORKFLOW_STEP_STATUS_ENUM.InternalQA,
  WORKFLOW_STEP_STATUS_ENUM.ClientQA,
  WORKFLOW_STEP_STATUS_ENUM.PostsManualEdit,
  WORKFLOW_STEP_STATUS_ENUM.FinalReportQA,
  WORKFLOW_STEP_STATUS_ENUM.PDFGeneration,
  WORKFLOW_STEP_STATUS_ENUM.WebContentReview,
  WORKFLOW_STEP_STATUS_ENUM.ArticlesManualEdit,
  WORKFLOW_STEP_STATUS_ENUM.WebContentScrape,
  WORKFLOW_STEP_STATUS_ENUM.InstagramPostScrape,
  WORKFLOW_STEP_STATUS_ENUM.XPostScrape,
  WORKFLOW_STEP_STATUS_ENUM.TiktokPostScrape,
  WORKFLOW_STEP_STATUS_ENUM.LinkedinPostScrape,
  WORKFLOW_STEP_STATUS_ENUM.FacebookPostScrape,
  WORKFLOW_STEP_STATUS_ENUM.YouTubePostScrape,
  WORKFLOW_STEP_STATUS_ENUM.RedditPostScrape,
  WORKFLOW_STEP_STATUS_ENUM.BlueskyPostScrape,
  WORKFLOW_STEP_STATUS_ENUM.InstantFit,
  WORKFLOW_STEP_STATUS_ENUM.Misconduct,
  WORKFLOW_STEP_STATUS_ENUM.CompleteReport,
  WORKFLOW_STEP_STATUS_ENUM.AmendmentQA,
  WORKFLOW_STEP_STATUS_ENUM.ThreeSixtyAmend,
];

export function StatusFilter({
  onChange,
  selectedStatus,
}: {
  onChange: (status: WORKFLOW_STEP_STATUS_ENUM[]) => void;
  selectedStatus: WORKFLOW_STEP_STATUS_ENUM[];
}) {
  const [prevSelectedStatus, setPrevSelectedStatus] = useState<
    WORKFLOW_STEP_STATUS_ENUM[]
  >([]);
  const [modalOpen, setModalOpen] = useState(false);

  const statusUI = WORKFLOW_STEP_STATUS_LIST.map((status) => ({
    ui: workStepNameToUI(status),
    status: status,
  }));

  useEffect(() => {
    setPrevSelectedStatus(selectedStatus);
  }, [selectedStatus]);

  const hasSelectedStatus = selectedStatus?.length > 0;

  const isPrevStatusSelected = (status: WORKFLOW_STEP_STATUS_ENUM) =>
    prevSelectedStatus.includes(status);

  return (
    <div
      className="border border-gray-200 rounded-lg p-2 pr-8 cursor-pointer relative"
      onClick={() => setModalOpen(true)}
    >
      {!hasSelectedStatus && (
        <div className="flex flex-row w-80 items-center relative">
          <div className="w-full pr-10 text-sm text-gray-500">
            Select Status
          </div>
        </div>
      )}
      {hasSelectedStatus && (
        <div className="flex flex-row gap-2">
          {selectedStatus.slice(0, 3).map((status) => (
            <div
              key={status}
              className={classNames(
                "p-1 rounded-lg text-xs",
                workStepNameToUI(status)?.color ?? "bg-gray-200"
              )}
            >
              {workStepNameToUI(status)?.name ?? ""}
            </div>
          ))}
          {selectedStatus.length > 3 && (
            <div className="p-1 rounded-lg bg-gray-200 text-xs">
              +{selectedStatus.length - 3}
            </div>
          )}
        </div>
      )}
      <FunnelIcon className="w-4 absolute right-2 top-1/2 -translate-y-1/2 text-gray-500" />
      {modalOpen && (
        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <div className="flex flex-col flex-wrap gap-2">
            {statusUI.map((status) => (
              <div
                key={status.status}
                className={classNames(
                  "p-1 rounded-lg cursor-pointer",
                  status?.ui?.color ?? "bg-gray-200",
                  isPrevStatusSelected(status.status)
                    ? "opacity-100"
                    : "opacity-20"
                )}
                onClick={() =>
                  setPrevSelectedStatus(
                    isPrevStatusSelected(status.status)
                      ? prevSelectedStatus.filter((s) => s !== status.status)
                      : [...prevSelectedStatus, status.status]
                  )
                }
              >
                {status.ui?.name ?? ""}
              </div>
            ))}
            <div>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  onChange(prevSelectedStatus);
                }}
                text={"apply"}
              ></Button>
              <button
                className="border-none underline text-sm text-gray-500  ml-3 focus:outline-none"
                onClick={() => {
                  setModalOpen(false);
                  onChange([]);
                }}
              >
                Clear All
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
